import { Modal } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { useChangeStoreModal } from "./useChangeStoreModal";

const ChangeStoreModal = ({
  showModal,
  setShowModal,
  handleStoreChange,
  stores,
  loading,
  fetchStores,
  storeId,
  storeName,
}) => {
  const { search, handleStoreSearch, inputRef, setSearch } =
    useChangeStoreModal(fetchStores, loading);
  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
        setSearch("");
        fetchStores();
      }}
      centered
      size="lg"
      className="select-store-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title as="h5" className="text-lg font-semibold">
          Select Store
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="px-3 pb-3">
          <div className="py-2">
            <div className="flex">
              <div className="flex-1">
                <input
                  type="search"
                  name="search"
                  id="storeSearch"
                  value={search}
                  onChange={handleStoreSearch}
                  className="w-full border-l border-t border-b border-r-0 p-2 pl-3 pr-4 rounded-tl-md rounded-bl-md focus:outline-none"
                  // disabled={loading}
                  placeholder="Search stores..."
                  autoComplete="off"
                  ref={inputRef}
                />
              </div>
              <div className="flex items-center justify-center px-2.5 bg-gray-100 border border-l-0 rounded-tr-md rounded-br-md">
                <FaSearch size={16} className="text-gray-400" />
              </div>
            </div>
          </div>

          <div className="py-2 pl-1 flex items-center gap-2">
            <p className="text-gray-600 text-sm font-medium font-sans">
              Current Store:
            </p>
            <span className="text-action text-sm">{storeName}</span>
          </div>

          <div className="h-[300px] overflow-y-auto pr-2 relative">
            {stores.length > 0 ? (
              <>
                {stores.map((store) => (
                  <div
                    key={store.iStoreId}
                    className={`py-3 px-2.5 border-b border-gray-200 cursor-pointer flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors duration-150 ${
                      store.iStoreId === storeId ? "bg-blue-50" : ""
                    }`}
                    onClick={() => handleStoreChange(store)}
                  >
                    <div className="flex-1">
                      <p className="text-gray-600 m-0 font-medium">
                        {store.sName} ({store.sStoreTypeName} {store.sStoreType}
                        )
                      </p>
                      <div className="text-xs text-gray-500 mt-1 flex gap-4">
                        <span>
                          Pending Products:{" "}
                          <span className="text-gray-800 font-semibold">
                            {store.iPendingProductCount ?? 0}
                          </span>
                        </span>
                        <span>
                          Pending Variants:{" "}
                          <span className="text-gray-800 font-semibold">
                            {store.iPendingVariantCount ?? 0}
                          </span>
                        </span>
                      </div>
                    </div>
                    {store.iStoreId === storeId && (
                      <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded whitespace-nowrap">
                        Current
                      </span>
                    )}
                  </div>
                ))}
              </>
            ) : !loading && search ? (
              <p className="text-center text-gray-400 py-4">No stores found</p>
            ) : !loading ? (
              <p className="text-center text-gray-400 py-4">
                Start typing to search stores
              </p>
            ) : null}

            {loading && (
              <div className="text-center py-4 text-gray-500">
                <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-gray-500 mr-2"></div>
                Loading...
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeStoreModal;
